query carteiraSelect {
    data: carteiras(order: [{nome: ASC}]) {
        value: codigo
        nome
        tipo
        label
    }
}